// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-DataExtraction-DataExtractionTemplate-components-OutcomesPanel-AddOutcome-AddOutcome-module__AddOutcome";
export { _1 as "AddOutcome" }
